import { RouteObject } from 'react-router';
import ModulesPage from './pages/modules';

export const routes: RouteObject[] = [
  {
    path: 'modules',
    element: <ModulesPage />,
  },
];
